import { Map, Set, OrderedMap } from 'immutable';

import * as types from './types';
import { MetricsRecord } from './../../records';
import { TOTAL_RUNS } from './../../constants';
import { clearSelectedVersion } from '../test-summary/utils';

const initialState = Map({
  trends: OrderedMap({
    status: Set(),
    browser: Set(),
    browserError: Set(),
    browserFail: Set(),
    os: Set(),
    osError: Set(),
    osFail: Set(),
    statusRecord: OrderedMap({
      totalRuns: new MetricsRecord({
        name: 'total-tests',
        title: TOTAL_RUNS,
        labelClassName: 'blue',
      }),
      passed: new MetricsRecord({
        title: 'Test Passed',
        labelClassName: 'success',
      }),
      errored: new MetricsRecord({
        title: 'Test Error',
        labelClassName: 'warning',
      }),
      failed: new MetricsRecord({
        title: 'Test Failed',
        labelClassName: 'danger',
      }),
      complete: new MetricsRecord({
        title: 'Test Completed',
      }),
    }),
  }),
  fadeMetrics: true,
  loadingData: true,
});

const testOverviewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_TEST_TRENDS.REQUEST:
      return state.set('fadeMetrics', false).set('loadingData', true);
    case types.GET_TEST_TRENDS.SUCCESS:
      return state.withMutations((newState) => {
        clearSelectedVersion(newState);

        Object.entries(payload.metrics).map(([key, metrics]) => newState.setIn(
          ['trends', key],
          Set(
            Object
              .entries(metrics)
              .map(([title, value]) => ({ title, value })),
          ),
        ));

        let totalTests = 0;
        Object.entries(payload.metrics.status)
          .forEach(([key, value]) => {
            totalTests += value;
            newState.setIn(['trends', 'statusRecord', key, 'value'], value);
          });
        newState.setIn(['trends', 'statusRecord', 'totalRuns', 'value'], totalTests);
        newState.set('fadeMetrics', true).set('loadingData', false);
      });
    case types.GET_TEST_TRENDS.FAILURE:
      return state.set('loadingData', false);
    case types.GET_PAST_TRENDS.SUCCESS:
      return state.withMutations((newState) => {
        let totalTests = 0;
        Object.entries(payload.metrics.status)
          .forEach(([key, value]) => {
            totalTests += value;
            newState.setIn(['trends', 'statusRecord', key, 'previousValue'], value);
          });
        newState.setIn(['trends', 'statusRecord', 'totalRuns', 'previousValue'], totalTests);
      });
    case types.CLEANUP_OVERVIEW:
      return initialState;
    default:
      return state;
  }
};

export default testOverviewReducer;
export { initialState };
